/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

var convertInitCount = 0;

var flavorMatrix = {
  19456851705910: 44179175309614,
  19456852131894: 44179175342382,
  15367924088886: 44179175375150,
  44179146965294: 44179175440686,
  44179150504238: 44179175506222,
  44179149324590: 44179175473454,
  31949827506230: 44179175407918,
  44179151094062: 44179175538990
}

// CHANGE ALL OF THESE TO LIVE SITE IDS (VARIANT_ID: SELLING_PLAN_ID)
var sellingPlanMatrix = {
  19456851705910: 691369050414,
  19456852131894: 691369050414,
  15367924088886: 691369050414,
  44179149324590: 691369050414,
  44179150504238: 691369050414,
  44179146965294: 691369050414,
  31949827506230: 691369050414,
  44179151094062: 691369050414,
  
  49763852910894: 691949699374,
  49763852943662: 691949699374
}

function subscribeSavingsCalc(totalShotsQty, totalGummiesQty) {
  var totalQty = totalShotsQty + totalGummiesQty;
  var totalSavings;

  if (totalQty < 3) {
    totalSavings = ((totalShotsQty * 23.99) - (totalShotsQty * 18.99)) + ((totalGummiesQty * 39.99) - (totalGummiesQty * 31.99))
  } else if (totalQty < 5) {
    totalSavings = ((totalShotsQty * 23.99) - (totalShotsQty * 16.72)) + ((totalGummiesQty * 39.99) - (totalGummiesQty * 28.16))
  } else {
    totalSavings = ((totalShotsQty * 23.99) - (totalShotsQty * 14.44)) + ((totalGummiesQty * 39.99) - (totalGummiesQty * 24.32))
  }
  return totalSavings.toFixed(2)
}

function discountCodeSummary(cart) {
  var titles = [];
  var amount = 0;
  var addTitle = function(title) {
    if (title && titles.indexOf(title) === -1) titles.push(title);
  };

  (cart.cart_level_discount_applications || []).forEach(function(application) {
    if (application.type !== 'discount_code') return;
    addTitle(application.title);
    amount += application.total_allocated_amount;
  });

  (cart.items || []).forEach(function(item) {
    (item.line_level_discount_allocations || []).forEach(function(allocation) {
      if (!allocation.discount_application || allocation.discount_application.type !== 'discount_code') return;
      addTitle(allocation.discount_application.title);
      amount += allocation.amount;
    });
  });

  return { titles: titles, amount: amount };
}

var shippingWasUnlocked = null;
var shippingCelebrateOnOpen = false;
var shippingCelebratedAt = 0;

function celebrateFreeShipping(bar) {
  if (Date.now() - shippingCelebratedAt < 1500) return;
  shippingCelebratedAt = Date.now();
  setTimeout(function() {
    if (!document.documentElement.classList.contains('js-drawer-open')) return;
    var old = bar.querySelector('.cart-shipping__burst');
    if (old) old.remove();
    var burst = document.createElement('span');
    burst.className = 'cart-shipping__burst';
    burst.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 24; i++) {
      burst.appendChild(document.createElement('span'));
    }
    bar.appendChild(burst);
    bar.classList.remove('is-celebrating');
    void bar.offsetWidth;
    bar.classList.add('is-celebrating');
    var price = document.querySelector('#CartDrawer .ajaxcart__shipping-price--free');
    if (price) price.classList.add('is-celebrating');
    setTimeout(function() {
      bar.classList.remove('is-celebrating');
      burst.remove();
    }, 1900);
  }, 350);
}

function updateShippingProgress(cart) {
  var bar = document.querySelector('#CartDrawer .cart-shipping');
  if (!bar) return;
  if (shippingWasUnlocked === null) {
    shippingWasUnlocked = bar.getAttribute('data-unlocked') === 'true';
  }
  if (!cart || !cart.item_count) {
    bar.hidden = true;
    shippingWasUnlocked = false;
    return;
  }
  var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 7500;
  var hasSubscription = cart.items.some(function(item) {
    return item.selling_plan_allocation != null;
  });
  var remaining = threshold - cart.total_price;
  var unlocked = hasSubscription || remaining <= 0;
  var percent = unlocked ? 100 : Math.round((cart.total_price / threshold) * 100);
  var copy = bar.querySelector('.cart-shipping__copy');
  var track = bar.querySelector('.cart-shipping__track');
  var fill = bar.querySelector('.cart-shipping__fill');

  if (unlocked) {
    copy.innerHTML = 'You\'ve unlocked <strong class="cart-shipping__free">FREE SHIPPING!</strong>';
  } else {
    copy.innerHTML = 'You\'re <strong class="cart-shipping__amount">$' + (remaining / 100).toFixed(2) + '</strong> away from <strong class="cart-shipping__free">FREE SHIPPING!</strong>';
  }
  bar.classList.toggle('is-unlocked', unlocked);
  fill.style.width = percent + '%';
  track.setAttribute('aria-valuenow', percent);
  bar.hidden = false;
  if (unlocked && (shippingWasUnlocked === false || shippingCelebrateOnOpen)) {
    celebrateFreeShipping(bar);
  }
  shippingCelebrateOnOpen = false;
  shippingWasUnlocked = unlocked;
}

/*============================================================================
  API Functions
==============================================================================*/
function fetchCartForSwap() {
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
      var updateData = ""
      var newCartJson = []

      if ($(".rewards__loading-overlay").length == 0) {
        $("body").append("<div class='rewards__loading-overlay'><div class='rewards__loading-spinner'></div></div>");
      } else {
        $(".rewards__loading-overlay, .rewards__loading-spinner").show();
      }

      $(".js-drawer-close").click()

      $.each(cart.items, function(i,v) {
        if (v.selling_plan_allocation == null) {
          newCartJson.push({
            quantity: v.quantity,
            id: v.id,
            selling_plan: sellingPlanMatrix[v.id]
          })
        }
      })

      $.post('/cart/clear.js').always(function(data) {
        $.post('/cart/add.js', { items: newCartJson }).always(function() {
          ajaxCart.load();
          $(".rewards__loading-overlay, .rewards__loading-spinner").hide();
        })
      })

      /*
      $.each(cart.items, function(i,v) {
        if (v.product_title == "Proper Wild 6 Pack") {
          updateData += "updates[" + v.variant_id + "]=0&"
          updateData += "updates[" + flavorMatrix[v.variant_id] + "]=" + v.quantity + "&"
        }
      })

      params = {
        type: 'POST',
        url: '/cart/update.js',
        data: updateData,
        dataType: 'json',
        success: function(cart) {
          // success
        },
        error: function(XMLHttpRequest, textStatus) {
          $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        },
        complete: function(jqxhr, text) {
          setTimeout(function(){
            $(".js-drawer-open-right").click()
            $(".rewards__loading-overlay, .rewards__loading-spinner").hide();
          }, 1000);
        }
      };
      jQuery.ajax(params);
      */
    });
  }


ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  console.log(jQuery(form))
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback, product) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart, product);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, unifySubscriptionInterval, updateSubscriptionIntervals;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    shippingCelebrateOnOpen = true;
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback, null);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    // Delegated so the override survives the subscribe page's buy-box swap;
    // the captured form/button sets are re-resolved from the submitting form.
    $(document).on('submit', settings.formSelector, function(evt) {
      evt.preventDefault();

      $formContainer = $(this);
      $addToCart = $formContainer.find(settings.addToCartSelector);

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);

    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    $(".site-header__cart-toggle .site-header__cart-count").show();
    

    ShopifyAPI.getCart(cartUpdateCallback, product);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  updateSubscriptionIntervals = function (cart, addedInterval, addedIntervalText, addedProductTitle) {
    var newCartJson = []

    $(".cart-frequency-tooltip .new-frequency").text(addedIntervalText)

    if (addedIntervalText == "every 3-months" || addedIntervalText == "every 5-months") {
      $(".cart-frequency-tooltip").addClass("tall")
    } else {
      $(".cart-frequency-tooltip").removeClass("tall")
    }

    if ($(".rewards__loading-overlay").length == 0) {
      $("body").append("<div class='rewards__loading-overlay'><div class='rewards__loading-spinner'></div></div>");
    } else {
      $(".rewards__loading-overlay, .rewards__loading-spinner").show();
    }

    var sellingPlanMatrix = $("#variant-selling-plan-matrix")
    var shotsSellingPlanMatrix = $("#variant-selling-plan-matrix").find(".shots-selling-plans div")
    var gummiesSellingPlanMatrix = $("#variant-selling-plan-matrix").find(".gummies-selling-plans div")

    var shotsToGummies = {}
    shotsToGummies[$(shotsSellingPlanMatrix[0]).data("id")] = $(gummiesSellingPlanMatrix[0]).data("id")
    shotsToGummies[$(shotsSellingPlanMatrix[1]).data("id")] = $(gummiesSellingPlanMatrix[1]).data("id")
    shotsToGummies[$(shotsSellingPlanMatrix[2]).data("id")] = $(gummiesSellingPlanMatrix[2]).data("id")
    
    var gummiesToShots = {}
    gummiesToShots[$(gummiesSellingPlanMatrix[0]).data("id")] = $(shotsSellingPlanMatrix[0]).data("id")
    gummiesToShots[$(gummiesSellingPlanMatrix[1]).data("id")] = $(shotsSellingPlanMatrix[1]).data("id")
    gummiesToShots[$(gummiesSellingPlanMatrix[2]).data("id")] = $(shotsSellingPlanMatrix[2]).data("id")

    $.each(cart.items, function(i,v) {
      if (v.selling_plan_allocation != null) {
        var newInterval = addedInterval
        
        if (v.product_title != addedProductTitle) {
          if (addedProductTitle == "Proper Wild Gummies 10-Pack") {
            newInterval = gummiesToShots[addedInterval]
          } else {
            newInterval = shotsToGummies[addedInterval]
          }
        }
        
        newCartJson.push({
          quantity: v.quantity,
          id: v.variant_id,
          selling_plan: newInterval
        })
      } else {
        newCartJson.push({
          quantity: v.quantity,
          id: v.variant_id
        })
      }
    })

    //console.log(newCartJson)

    $.post('/cart/clear.js').always(function(data) {
      $.post('/cart/add.js', { items: newCartJson }).always(function() {
        ShopifyAPI.getCart(function(freshCart) {
          buildCart(freshCart);
          $(".rewards__loading-overlay, .rewards__loading-spinner").hide();
          $(".cart-frequency-tooltip").show();

          if ($(".account__loading-overlay").length == 0) {
            $("body").append("<div class='account__loading-overlay'></div>");
          } else {
            $(".account__loading-overlay").show();
          }
        }, null);
      })
    })
  }

  unifySubscriptionInterval = function (cart, product) {
    if (product != null && product.selling_plan_allocation != null) {
      var addedInterval = product.selling_plan_allocation.selling_plan.id
      var sellingPlanName = product.selling_plan_allocation.selling_plan.name
      var intervalUpdateNeeded = false
      $.each(cart.items, function(index, cartItem) {
        if (cartItem.selling_plan_allocation != null && cartItem.selling_plan_allocation.selling_plan.name != sellingPlanName) {          intervalUpdateNeeded = true;
        }
      })
      if (intervalUpdateNeeded) {
        var addedIntervalText = "monthly"

        if (sellingPlanName == "Delivery every 3 Months") {
          addedIntervalText = "every 3-months"
        } else if (sellingPlanName == "Delivery every 5 Months") {
          addedIntervalText = "every 5-months"
        }
        
        updateSubscriptionIntervals(cart, addedInterval, addedIntervalText, product.product_title)
        return true;
      }
    }
    return false;
  };

  cartUpdateCallback = function (cart, product) {
    // Check to see if the newly added product is a different frequency than current cart subscription items
    var needsUnify = unifySubscriptionInterval(cart, product);
    // Update quantity and price
    updateCountPrice(cart);
    // Skip immediate render when unification is in progress —
    // updateSubscriptionIntervals will fetch fresh cart data and call buildCart
    if (!needsUnify) {
      buildCart(cart);
    }
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $(".site-header__cart-count").hide();
      $cartContainer
        .append('<p class="ajaxcart__empty-message">' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _medium, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var new_url = cartItem.url;
      if(cartItem.properties){
        var item_properties = cartItem.properties;
        if (item_properties.subscription_id){
          var new_url = "/products/" + cartItem.handle;
          new_url = new_url.slice(0, -2);
        }
      }

      var variantSubscriptions = {}
      
      $(".data-subscription-variants .data-product-variant").each(function() {
        var el = $(this)
        variantSubscriptions[el.data("subscription-id")] = {
          id: el.data("variant-id"),
          image: el.data("image")
        }
      })

      var rootVariantId = cartItem.variant_id
      if (variantSubscriptions[rootVariantId]) {
        prodImg = variantSubscriptions[rootVariantId].image
        rootVariantId = variantSubscriptions[rootVariantId].id
        new_url += "?variant=" + rootVariantId
      } else {
        new_url += "&one-time=true"
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: new_url,
        img: prodImg,
        productId: cartItem.product_id,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        subscriptionFrequency: cartItem.selling_plan_allocation == null ? null :
          cartItem.selling_plan_allocation.selling_plan.name,
        isSubscription: cartItem.selling_plan_allocation == null ? false : true
      };

      items.push(item);
    });

    var codeDiscount = discountCodeSummary(cart);
    var shippingFree = cart.total_price >= 7500 || cart.items.some(function(cartItem) {
      return cartItem.selling_plan_allocation != null;
    });

    // Gather all cart data and add to DOM
    data = {
      discountCodeApplied: codeDiscount.amount > 0,
      discountCodeTitles: codeDiscount.titles.join(', '),
      discountCodeAmount: Shopify.formatMoney(codeDiscount.amount, settings.moneyFormat),
      discountedTotal: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      items: items,
      shippingFree: shippingFree,
      shippingPrice: Shopify.formatMoney(800, settings.moneyFormat),
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.original_total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);
    
    jQuery.getJSON('/cart.js', function (fetchedCart, textStatus) {
      updateShippingProgress(fetchedCart)

      // Check if cart contains one time items
      var containsOneTime = false
      var containsSubscription = false
      var totalShotsQty = 0
      var totalGummiesQty = 0
      
      $.each(fetchedCart.items, function(i,v) {
        if (v.selling_plan_allocation == null) {
          containsOneTime = true
          if (window.shotsIds && window.shotsIds.includes(v.product_id)) {
            totalShotsQty += v.quantity
          } else {
            totalGummiesQty += v.quantity
          }          
        } else {
          containsSubscription = true
        }
      })

      if (containsOneTime && !containsSubscription) {
        var shippingSavings = fetchedCart.total_price < 7500 ? 8 : 0
        var subscribeSavings = parseFloat(subscribeSavingsCalc(totalShotsQty, totalGummiesQty)) + shippingSavings
        $(".ajax-cart-subscribe-save-amount span").text(subscribeSavings.toFixed(2))
        $(".convert-to-subscription-link").show()
        $(".ajax-cart-subscribe-save-amount p").show()
        $(".drawer__header").addClass("subscribe-save")

        if (convertInitCount == 0) {
          $("a.convert-to-subscription-link").click(function(e) {
            e.preventDefault()
            fetchCartForSwap()
            ga('send', 'event', 'click', 'minicart_subscription_conversion')
            gtag("event", "minicart_subscription_conversion", {});
          })
          convertInitCount += 1
        }
      } else {
        $(".ajax-cart-subscribe-save-amount p").hide()
        $(".convert-to-subscription-link").hide()
        $(".drawer__header").removeClass("subscribe-save")
      }   
    }) 

    if (window.cartUpdateLine) {
      var ajaxCartRowSelector = ".ajaxcart__row[data-line='" + window.cartUpdateLine + "']"
      var changedRowPosition = $(ajaxCartRowSelector).closest(".ajaxcart__product").position().top
      $(".ajaxcart__inner").scrollTop(changedRowPosition - 100)
      window.cartUpdateLine = null;
    }

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }

    // Change bulk discount messaging based on contents of cart
    var numSubscriptionItems = 0;
    var numOneTimeItems = 0;
    var oneTimeItemsSubtotal = 0;
    var subscriptionShotsQty = 0;
    var subscriptionGummiesQty = 0;

    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].selling_plan_allocation != null) {
        numSubscriptionItems = numSubscriptionItems + cart.items[i].quantity;
        // Classify by id (window.shotsIds), not product_title — flavor products
        // don't match a hardcoded title. Each line is then priced at its exact
        // bulk-tier per-unit rate (what the buy-box button and checkout charge),
        // so it's exact for shots AND gummies.
        if (window.shotsIds && window.shotsIds.includes(cart.items[i].product_id)) {
          subscriptionShotsQty += cart.items[i].quantity
        } else {
          subscriptionGummiesQty += cart.items[i].quantity
        }
      } else {
        numOneTimeItems = numOneTimeItems + cart.items[i].quantity;
        oneTimeItemsSubtotal += cart.items[i].final_line_price
      }
    }

    if (window.innerWidth < 769) {
      $("#CartContainer .ajaxcart__inner").css("height", (document.documentElement.clientHeight - 435));
    }

    var bulkDiscountTotal = 0;
    var bulkDiscountPercent = 0;
    var subscriptionBulkDiscountTotal = 0;

    // Per-unit bulk-tier rates (from V2_PRICING): shots 6-pack, gummies 10-count.
    if (numSubscriptionItems >= 5) {
      bulkDiscountPercent = 40
      subscriptionBulkDiscountTotal = (subscriptionShotsQty * 14.44) + (subscriptionGummiesQty * 24.32)
    } else if (numSubscriptionItems >= 3) {
      bulkDiscountPercent = 30
      subscriptionBulkDiscountTotal = (subscriptionShotsQty * 16.72) + (subscriptionGummiesQty * 28.16)
    }

    if (discountCodeSummary(cart).amount > 0) {
      $(".ajaxcart__bulk-discount-details").hide()
      $(".ajaxcart__subtotal").addClass("bulksubscriptionsubtotal")
    } else if (numSubscriptionItems >= 3) {
      $(".ajaxcart__activatebulk-label").hide()
      $(".ajaxcart__activatebulk-code").text("(" + bulkDiscountPercent + "% Off)")
      $(".ajaxcart__bulk-discount-details").show()
      bulkDiscountTotal = subscriptionBulkDiscountTotal + (oneTimeItemsSubtotal / 100)

      $(".ajaxcart__subtotal_subscribediscount").text("$" + (bulkDiscountTotal).toFixed(2))
      $(".ajaxcart__subtotal").addClass("bulksubscriptionsubtotal")
    } else {
      $(".ajaxcart__activatebulk-label").show()
      $(".ajaxcart__bulk-discount-details").hide()
      $(".ajaxcart__subtotal").removeClass("bulksubscriptionsubtotal")
    }

    if (numSubscriptionItems == 0) {
      $(".ajaxcart__activatebulk-label a").attr("href", "/pages/subscribe")
      $(".ajaxcart__activatebulk-label a").removeClass("show-tooltip")
    } else {
      $(".ajaxcart__activatebulk-label a").attr("href", "#")
      $(".ajaxcart__activatebulk-label a").addClass("show-tooltip")
    }

    $(".ajaxcart__activatebulk-label .show-tooltip").click(function(e) {
      e.preventDefault()
      $('.cart-bulk-discoun-tooltip').show()
      $("body").append("<div class='account__loading-overlay'></div>");
    })
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Handle remove link
    $body.on('click', '.ajaxcart__remove-link', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = 0;

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    })

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;
      if (qty > 0) {
        window.cartUpdateLine = line;
      }

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // A failed change (stale line number, concurrent edit in another tab)
    // must not leave the drawer dead: clear the busy flag and rebuild from
    // the server cart so the row line numbers resync.
    $body.on('errorChangeItem.ajaxCart', function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart, null);
    });

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed.
    // isUpdating must stay true until the rebuilt rows are in the DOM — the
    // old rows carry pre-change line numbers, and a click on them lands on
    // lines that no longer exist (422 "line parameter is invalid").
    setTimeout(function() {
      ShopifyAPI.getCart(function(freshCart) {
        buildCart(freshCart);
        isUpdating = false;
      }, null);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        if ($("#sms-opt-in").length == 0) {
          $el.after(template(data)).remove();
        }
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').not("#product_quantity_wrapper .js-qty__adjust").on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, '')),
            line = $el.data('line');

        var qty = validateQty(qty);
        $el.addClass("qty-initialized");

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        if ($("body").hasClass("template-cart")) {
          ShopifyAPI.changeItem(line, qty, function() {
            location.reload();
          })
        } else {
          $qtySelector.val(qty);
          
        }

        $("#AddToCart .add-to-cart-price").text("$" + (qty * 21).toFixed(2))
        priceChange(qty)
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));


/*============================================================================
  Handle Dynamic Price Changes
==============================================================================*/

function priceChange(qty) {
  // Guard: v2 buy box manages its own tiered pricing — do not overwrite
  if (document.querySelector('.v2-buy-box')) return;

  if ($(".product-details-container .product-name").text().trim() == "Clean Energy Shots") {
    var price = 23.99;
    var subPrice = 18.99;
    var servings = 6;
  } else {
    var price = 39.99;
    var subPrice = 31.99;
    var servings = 10;
  }

  var discount = 1;
  
  if ($(".purchase-type-buttons .cta-black").attr("data-type") == "subscription") {
    discount = 0.79158;
  }
  var discountPrice = (qty * price * discount).toFixed(2)
  $(".product-selected-price").text("$" + discountPrice)
  $(".product-single .shot-number").text(qty * servings)
  $(".old-price").text("$" + (qty * price).toFixed(2))
}

$(document).ready(function() {
  var purchaseTypeSelector = ".purchase-type-radio-buttons input"
  // Delegated so the handler survives the subscribe page's buy-box swap
  $(document).on('click touchstart', purchaseTypeSelector, function(e) {
    if ($(".js-drawer-open").length < 1) {
      var target = $(e.target)    
      var quantity = $(".js-qty .js-qty__num").val()
      
      priceChange(quantity || 1)

      // Delays to handle open mini cart and slow loading ReCharge Widget
      setTimeout(function() {
        $(".shot-price").css("opacity", 0.5)
        if (target.attr("data-type") == "subscription") {
          $(".old-price").show()
          $(".purchase-type-label").text("Monthly")
          $("#AddToCart").text("Subscribe")
          $(".rc_widget__option__input--subsave").click()
          $(".rc_radio__autodeliver").click()
          $(".shot-price-subscription").css("opacity", 1)
          $('.subscription-price-table-cont').show();
          $('.frequency-wrapper').show();
        } else {
          $(".old-price").hide()
          $(".purchase-type-label").text("One-Time")
          $(".shot-price-one-time").css("opacity", 1)
          $("#AddToCart").text("Add To Cart")
          $('.subscription-price-table-cont').hide();
          $('.frequency-wrapper').hide();
          // $('.price-container').show();
          $(".rc_widget__option__input--onetime").click()
          /* 
          var clear = setInterval(clickHandler, 100)
          function clickHandler() {
            if ($("#rc_container").css("display") == "block") {
              $(".rc_radio__onetime").trigger("click")
              clearInterval(clear)
            }
          }
          */
        }
      }, 100)
    }
  })
});






















